export default __webpack_public_path__ + "static/media/TrialUserFrencyTemplate.05e0a325.png";